module.exports = __webpack_public_path__ + "static/media/nutricion1.6ef671fc.png";